import { useEffect, useState } from 'react';

// Tracks live viewport width/height so layout decisions can be based on the
// actual available space rather than a fixed device-type breakpoint.
// Re-evaluates on resize AND orientationchange (some mobile browsers fire
// orientationchange slightly before/without a reliable resize event).
export const useViewportSize = () => {
  const [size, setSize] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  }));

  useEffect(() => {
    const update = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return size;
};

export default useViewportSize;
